import { ReactElement, SVGAttributes, FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { Badge, BadgeType } from "@components/new/Badge";
import NeutralIcon from "@assets/icons/solid/circle-info.svg?react";
import SuccessIcon from "@assets/icons/solid/circle-check.svg?react";

const WithdrwalStatusBadge = ({ value }: {
  value?: string;
}): ReactElement => {
  const { t } = useTranslation();

  const getStatusType = (status: string) => {
    const statuses: Record<string, BadgeType> = {
      Created: BadgeType.SECONDARY,
      Accepted: BadgeType.PRIMARY,
      Assembled: BadgeType.PRIMARY,
      Completed: BadgeType.PRIMARY,
      Canceled: BadgeType.DESTRUCTIVE,
      Destroyed: BadgeType.DESTRUCTIVE,
    }
    return statuses[status] ?? BadgeType.SECONDARY;
  }

  const getStatusIcon = (status: string) => {
    const statuses: Record<string, FunctionComponent<SVGAttributes<SVGElement>>> = {
      Completed: SuccessIcon,
      Rejected: NeutralIcon,
    }
    return statuses[status] ?? null;
  }

  return (
    <Badge
      type={getStatusType(value ?? "")}
      iconLeft={getStatusIcon(value ?? "")}
    >
      {t(`fbpPage.withdrawalStatuses.${value}`)}
    </Badge>
  );
};

export default WithdrwalStatusBadge;
